module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAXVBMVEUAAADS1dbR1dXR09XS09XR1NXS09XS09XS09bT09jR09XS09XS09XR1dXV19nS09XR1dXT09jS09bR1NXR1NXS09XS1NbX2NrS09XS0tjS1dXS09bR1NfT09bS09WFzTyRAAAAHnRSTlMABgqT6XH47NxMGvTwaRXiZ0/Zc4VtXpORRRDUWkK/2B+ZAAAAwElEQVQoz13R2xKCIBSF4YUHKCVQU0sr3v8x4yCz0H3lfP/owBYwr2XHabq5FcFl31alm1oqL7V0Tpele3tRCwbtYqH3HuyGalD+QeXS1cFvdwGIocmFDiCX5lmVnsojFZjo0+Esc/LxUBYp6SzWxfkczpl1cLte3dQp8KblvfKpS5cerQ03zYU+fR+XYqLfxnhq7o2OULjrwsF38ve5t0HFdwxmR2fpV7TqcBYdRSyNTc696Sn8wWr9CZxmHzfgDzt2FYBT3bndAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./web/img/lottery/close.png
// module id = 976
// module chunks = 79 82